import { render, staticRenderFns } from "./ResourcePercent.vue?vue&type=template&id=47f71a46&"
import script from "./ResourcePercent.vue?vue&type=script&lang=js&"
export * from "./ResourcePercent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports